import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        isLogged: false,
        name: '',
        surname:'',
        id: '',
        url: 'http://www.st.fmph.uniba.sk/~torma6/phpserver/',//'http://localhost:80/', // nasadzovanie - http://www.st.fmph.uniba.sk/~torma6/phpserver/
    },
    mutations: {
        logout(state) {
            state.isLogged = false;
        },
        setLoggedUser(state,  { name, surname, id }) {
            state.isLogged = true;
            state.name = name;
            state.surname = surname;
            state.id = id;
        }
    },
    getters: {
        getIsLogged: state => {
            return state.isLogged
        },
        getName: state => {
            return state.name
        },
        getSurname: state => {
            return state.surname
        },
        getUrl: state => {
            return state.url
        }
    }
})
export default store;